import React, {useState} from "react"
import {useHistory} from "react-router-dom"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
// Colors
import ComponentWrapper from "components/HOC/ComponentWrapper/index"
import {
	SearchInput,
	SearchInputContainer,
	SearchInputfigure,
	SearchInputImage,
	Container,
	HomeImage,
	HomeTitle,
	EmployerHomeDescription,
	EmployerButton
} from "./index.style"
import ReportsIcon from "assets/images/png/icon-reports.png"
import IconSearch from "assets/images/icons/svg/search.svg"

const Reports = () => {
	const history = useHistory()
	const [reportsSearchTermText, setReportsSearchTermText] = useState("")
	const handleSearch = value => {
		setReportsSearchTermText(value)
	}

	const handleClick = () => {
		const data = reportsSearchTermText
		history.push("/reports/employers", {data})
	}

	const disableSearchButton = !reportsSearchTermText.trim().length

	return (
		<ComponentWrapper menuActiveIndex={5} headerTitle='Reports'>
			<Card padding={spacing.s10} backgroundColor='white'>
				<Container>
				<HomeImage src={ReportsIcon} />

				<HomeTitle>Generate Report</HomeTitle>

				<EmployerHomeDescription>
					Here you will be able to find Reports related to a specific Employers and Download and/or Email it
					to a relevant Contact.
				</EmployerHomeDescription>

				<SearchInputContainer>
					<SearchInputfigure>
						<SearchInputImage src={IconSearch} />
					</SearchInputfigure>
					<SearchInput
						type={"text"}
						label={"email"}
						onChange={e => handleSearch(e.target.value)}
						placeholder={"Search by Employer code, Company Name, or Main Contact"}
						data-testid='searchByEmployerCode'
						isRequired={false}
					/>
				</SearchInputContainer>
				<br />
				<EmployerButton size={"Medium"} onClick={handleClick} title={"Search"} disabled={disableSearchButton}/>
				</Container>
			</Card>
		</ComponentWrapper>
	)
}

export default Reports
